export default [
  {
    label: 'Все',
    value: -1,
    filterFn: () => true,
  },
  {
    label: 'Открытый',
    value: 1,
    filterFn: (account) => !account.closed,
  },
  {
    label: 'Закрытый',
    value: 2,
    filterFn: (account) => account.closed,
  },
];
